import { type PanoramaClientForComponent } from '@wix/fe-essentials/panorama-client';
import { createContext, useContext } from 'react';

import { useForm } from './form-context';

export interface PanoramaProps {
  panorama?: PanoramaClientForComponent;
}

export const PanoramaContext = createContext<PanoramaProps | undefined>(
  undefined,
);

export function usePanorama() {
  const context = useContext(PanoramaContext);
  if (context === undefined) {
    throw new Error('usePanorama must be used within a PanoramaProvider');
  }

  const panorama = context.panorama;
  const { namespace } = useForm();

  return {
    transaction: (name: string) => ({
      start: () => panorama?.transaction(name).start({ namespace }),
      finish: () => panorama?.transaction(name).finish({ namespace }),
    }),
  };
}
